module.exports = __webpack_public_path__ + "static/media/screens-nft.71893c2b.jpg";